var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI06HeadphoneFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.43776 23.3123C2.92526 23.3123 2.50026 22.8873 2.50026 22.3748V15.2498C2.43776 11.8623 3.70026 8.66226 6.05026 6.26226C8.40026 3.87476 11.5503 2.56226 14.9378 2.56226C21.8628 2.56226 27.5003 8.19976 27.5003 15.1248V22.2498C27.5003 22.7623 27.0753 23.1873 26.5628 23.1873C26.0503 23.1873 25.6253 22.7623 25.6253 22.2498V15.1248C25.6253 9.23726 20.8378 4.43726 14.9378 4.43726C12.0503 4.43726 9.37526 5.54976 7.38776 7.57476C5.38776 9.61226 4.32526 12.3248 4.37526 15.2248V22.3623C4.37526 22.8873 3.96276 23.3123 3.43776 23.3123Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.425 15.5627H7.2625C4.6375 15.5627 2.5 17.7002 2.5 20.3252V22.6752C2.5 25.3002 4.6375 27.4377 7.2625 27.4377H7.425C10.05 27.4377 12.1875 25.3002 12.1875 22.6752V20.3252C12.1875 17.7002 10.05 15.5627 7.425 15.5627Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7375 15.5627H22.575C19.95 15.5627 17.8125 17.7002 17.8125 20.3252V22.6752C17.8125 25.3002 19.95 27.4377 22.575 27.4377H22.7375C25.3625 27.4377 27.5 25.3002 27.5 22.6752V20.3252C27.5 17.7002 25.3625 15.5627 22.7375 15.5627Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI06HeadphoneFull);
export default __webpack_public_path__ + "static/media/I06-headphone_full.2ad09b4229e21fa5da9f1458e622edba.svg";
export { ForwardRef as ReactComponent };